import { Modal, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";

import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import { getGatewayStudyStatusAPI } from "../../../../../service/StudyListService";

const GatewayStatus = (props) => {
  const [loading, setLoading] = useState(false);
  const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
  const [gatewayStudyStatusData, setGatewayStudyStatusData] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [actionResponseMessage, setActionResponseMessage] = useState("");
  const [t] = useTranslation();

  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => props.setShowGatewayStudyStatusModal(false),
    },
  ];

  const getGatewayStudyStatus = async() =>{
    setLoading(true);
    const response = await getGatewayStudyStatusAPI(props.studyId);
    console.log("Gateway Study Status data :", response)
    if (response.status == 200 && response.data.result == "SUCCESS") {
      if(response.data.data != null && response.data.data != undefined){
        setGatewayStudyStatusData(response.data.data);
      }else{
        setResponseMessage(response.data.message);
      }
      
      setLoading(false);
    } else {
      setLoading(false);
    }
    
  }

  useEffect(() => {
    getGatewayStudyStatus();
  }, []);

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal = {true}
        heading={`${t("gateway-study-status.title")}`}
        handleCancel={() => props.setShowGatewayStudyStatusModal(false)}
      />
    ),
    body: <GatewayStudyStatusModal responseMessage={responseMessage} 
      loading={loading} gatewayStudyStatusData = {gatewayStudyStatusData} actionResponseMessage={actionResponseMessage} />,
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={PrimaryButtonList}
      />
    ),
    width: "785px",
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={props.showGatewayStudyStatusModal}
      />
    </>
  );
};

export default GatewayStatus;

export const GatewayStudyStatusModal = (props) => {
  const [t] = useTranslation();
  const { getThemeColor } = useContext(themeContext);

  const tableStyle = {
    width: "100%",
    color: getThemeColor("primary-color"),
    fontWeight: "400",
    fontFamily: "Open Sans",
  };

  const headStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
  };

  const bodyRowDataStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
  };

  const reasonBodyStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
    wordBreak: "break-all",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px"
  };

  const contentStyles = {
    root: {
      backgroundColor: "rgb(22, 21, 20, 0.7)",
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: getThemeColor("primary-color"),
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const thheadStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
    borderBottom:'none'
  };


  return (
    <>
      {props.loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <div className="upload-study-modal-container">
          <div className="container-content">
            {Object.keys(props.gatewayStudyStatusData).length !== 0 ? (
              <>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <React.Fragment>
                      <th style={thheadStyle}>{t("gateway-study-status.application")} </th>
                      <th style={thheadStyle}>{t("gateway-study-status.image-count")} </th>
                      <th style={thheadStyle}>{t("gateway-study-status.series-count")}</th> 
                    </React.Fragment>
                  </tr>
                  <tr style={headStyle}></tr>
                  <tr style={headStyle}></tr>
                  <tr style={headStyle}></tr>
                </thead>
                <tbody id="unassign-modal_body">
                    <tr>
                      <td style={bodyRowDataStyle}>{"Gateway"} </td>
                      <td style={bodyRowDataStyle}>{props.gatewayStudyStatusData.gatewayImageCount} </td>
                      <td style={bodyRowDataStyle}>{props.gatewayStudyStatusData.gatewaySeriesCount} </td>
                    </tr>
                    <tr>
                      <td style={bodyRowDataStyle}>{"Augmento"} </td>
                      <td style={bodyRowDataStyle}>{props.gatewayStudyStatusData.augmentoImageCount} </td>
                      <td style={bodyRowDataStyle}>{props.gatewayStudyStatusData.augmentoSeriesCount} </td>
                    </tr>
                </tbody>
              </table>
              <div style={{display : "flex", alignItems : "center"}}>
                <p style={{textAlign : "left", paddingTop : "5px"}}>Last Updated At: {props.gatewayStudyStatusData.lastUpdatedAt}</p>
                <p style={{marginLeft : "20px", paddingTop : "5px"}}>Last Status: {props.gatewayStudyStatusData.lastStatus}</p>
                <p style={{marginLeft : "20px", paddingTop : "5px"}}>Sync Status: {props.gatewayStudyStatusData.syncStatus}</p>
              </div>
              </>
            ) : (
              <p style={noReason}>{props.responseMessage}</p>
            )}
            {props.actionResponseMessage != "" && 
              <p style={noReason}>{props.actionResponseMessage}</p>
            }
          </div>
        </div>
      )}
    </>
  );
};
